import * as React from 'react';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('main');
const root = createRoot(container!); 
import './localization/i18n';
import MancalaApp from './MancalaApp';
root.render(<MancalaApp/>);